function ChevronLeft(props) {
  return (
    <svg
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.15969 4.99996L5.34042 1.95232C5.70005 1.60774 5.70005 1.03294 5.34042 0.688356C5.00189 0.363986 4.46788 0.363986 4.12934 0.688355L0.262014 4.39387C0.0942489 4.55461 -4.07782e-07 4.77263 -4.27655e-07 4.99996C-4.47529e-07 5.22729 0.0942488 5.44531 0.262014 5.60605L4.12934 9.31156C4.46788 9.63593 5.00189 9.63593 5.34042 9.31156C5.70005 8.96698 5.70005 8.39218 5.34042 8.0476L2.15969 4.99996Z"
      fill="#111111"
    />
  </svg>
  )
}

export default ChevronLeft
